export const truncateAt = (value?: string, maxLength = 200) => {
    return value ? `${value}${value.length > maxLength ? "..." : ""}` : value
}

// Cloud Run does not react well to large strings in logs, so we truncate them
export const shortStringify = (value?: unknown, maxLength = 1000) => {
    return truncateAt(JSON.stringify(value), maxLength)
}
